var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.wording && _vm.wording[_vm.submission_id] && _vm.wording[_vm.submission_id][_vm.area] && _vm.wording[_vm.submission_id][_vm.area][_vm.textkey])?_c('span',{domProps:{"innerHTML":_vm._s(_vm.wording[_vm.submission_id][_vm.area][_vm.textkey])}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }